<template>
  <v-app-bar
    app
    color="white"
    clipped-left
    elevation="1"
    class="rai-app-toolbar"
    height="64px"
  > 
    <router-link to="/">
      <img
        src="@/assets/logo.png"
        class="rai-logo"
      />
    </router-link>
    <v-spacer></v-spacer>
    <v-divider
      class="mx-4"
      vertical
    />
    <app-avatar
      :user-name="user ? user.name : ''"
      :user-email="user ? user.email: ''"
      :is-parameterizer="isUserParameterizer"
    />
    <v-divider
      class="mx-4"
      vertical
    />
    <locale-changer/>
    <v-divider
      class="mx-4"
      vertical
    />
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="logout"
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
          :loading="logoutLoading"
        >
          <v-icon class="rai-edit-project-btn" dark>mdi-power</v-icon>
          <template v-slot:loader>
            <span class="rai-custom-loader__button">
              <v-icon dark>mdi-cached</v-icon>
            </span>
          </template>
        </v-btn>
      </template>
      <span>{{ $t('global.logout') }}</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import { Auth } from '@aws-amplify/auth';
import LocaleChanger from '@/components/global/LocaleChanger';
import AppAvatar from '@/components/global/AppAvatar';
import userRightMixin from '@/mixins/user-right-mixin.js';

export default {
  name: "AppToolbar",

  components: { LocaleChanger, AppAvatar },

  mixins: [ userRightMixin ],

  data: () => ({
    logoutLoading: false,
  }),

  computed: {
    ...mapState(['user',]),
  },

  methods: {
    logout () {
      this.logoutLoading = true;
      Auth.signOut().then(() => {
        this.$store.dispatch('logoutCognitoUser');
        this.$router.push({ name: 'login' });
      }).catch(err => {
        console.log('error signing out: ', err);
      }).finally(() => {
        this.logoutLoading = false;
      });
    },
  },
};
</script>

<style>
.rai-logo {
  width: 153px;
  height: 44px;
}
</style>